<template>
    <div class="search-button">
                <el-input v-model="input" placeholder="请输入内容" style="width: 980px;" @change ="selectInput()">
                    <i slot="suffix" class="el-input__icon el-icon-search" @click="selectInput()" style="cursor: pointer;"></i>
                </el-input>
            </div>
</template>
<script>
    export default {
        data(){
            return{
                input: ''
            }
        },
        props: ['maintypeIds','Newkeywords'],
        watch: {
            Newkeywords(newVal,oldVal){

                this.input = newVal
            }
        },
        methods: {
           
            selectInput(){
                    
                this.$emit('inputKey',this.input)
            },
            // getArryList(data){
            //     this.$store.dispatch('menu/getMenu',data)
            //         .then(res => {
            //             console.log(res);
            //             if(res.ok){
            //                 this.$emit('ListArticle', res.data);

            //             }
            //         }).catch(err => {
            //             console.log(err);
            //         })
            // }
        }
    }
</script>
<style scoped>
.search-button{
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
}
.search-button .el-input__inner {
    border-radius: 50px;
}

.search-button .el-button{
    border-radius: 20px;
}

</style>